<template>
  <div>
    <v-toolbar id="content-toolbar" flat class="elevation-1 sticky toolbar-scroll">
      <v-btn large flat href="#overview">
        {{ __('Overview') }}
      </v-btn>
      <v-btn large flat href="#learning-outcomes">
        {{ __('Learning Outcomes') }}
      </v-btn>
      <v-btn large flat href="#course-outline">
        {{ __('Course Outline') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn large flat color="secondary" href="/contact-us">
        {{ __('Request Info') }}
      </v-btn>
      <v-btn large color="secondary" href="/contact-us">
        {{ __('Apply Now') }}
      </v-btn>
    </v-toolbar>

    <v-container grid-list-lg>
      <v-layout row wrap justify-center align-center>
        <v-flex xl8 lg10 md12 xs12>
          <div class="mb-5">
            <v-layout row wrap>
              <v-flex
                :md8="item.md8"
                xs12>
                <v-card id="overview" flat>
                  <div style="height:60px;"></div>
                  <v-card-text>
                    <h1 class="mb-3 primary--text">
                      {{ trans('Overview') }}
                    </h1>
                    <p v-html="trans(item.overview)"></p>
                  </v-card-text>
                </v-card>

                <v-card id="learning-outcomes" flat>
                  <div style="height:60px;"></div>
                  <v-card-text>
                    <h1 class="mb-3 primary--text">
                      {{ trans('Expected Learning Outcomes') }}
                    </h1>
                    <p v-html="trans(item.outcome)"></p>
                  </v-card-text>
                </v-card>

                <v-card id="course-outline" flat>
                  <div style="height:60px;"></div>
                  <v-card-text>
                    <h1 class="mb-3 primary--text">
                      {{ trans('Course Outline') }}
                    </h1>
                    <p v-html="trans(item.outline)"></p>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex md4 xs12>
                <div style="height:60px;"></div>
                <v-card v-if="item.audience.showTargetAudience">
                  <v-card-text class="grey lighten-5">
                    <h4 class="body-2">
                      <strong>{{ trans('Target Audience') }}</strong>
                    </h4>
                  </v-card-text>
                  <div class="mt-3">
                    <template v-for="(item, i) in item.audience.items">
                      <v-card-text
                        :key="i"
                        class="px-4 py-3"
                        >
                        <v-layout row justify-start align-start>
                          <v-avatar
                            color="blue lighten-5"
                            size="30"
                            class="mr-3"
                            >
                            <v-icon
                              color="secondary"
                              small
                              v-html="item.icon"
                              >
                            </v-icon>
                          </v-avatar>
                          <p v-html="item.title"></p>
                        </v-layout>
                      </v-card-text>
                    </template>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'
import AOS from 'aos'
import 'aos/dist/aos.css'
import $ from 'jquery'

export default {
  store,
  name: 'SectionContent',

  components: {
    AOS,
  },

  mounted () {
    this.scrollNav()
  },

  methods: {
    scrollNav () {
      /*eslint-disable*/
      // Select all links with hashes
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      // .not('[href="#"]')
      // .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            // event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 700, function() {
              // Callback after animation
              // Must change focus!
              // var $target = $(target);
              // $target.focus();
              // if ($target.is(":focus")) { // Checking if the target was focused
              //   return false;
              // } else {
              //   $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              //   $target.focus(); // Set focus again
              // };
            });
          }
        }
      });
    }
  },

  props: {
    item: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    }
  },
}
</script>
